<template>
  <div class="popUpWrap">
    <section class="popup dark basic">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t("skillMonitor-assessment-send-report-title") }}</h5>
          <p v-html="getDescriptionToHtml" />
        </div>
        <label>
          <input type="text" v-model="email" :class="{error: !isValidEmail && email.length > 0}" :placeholder="t('account-email')">
        </label>
        <p v-if="!isValidEmail && email.length > 0" class="errorMessage"><span></span>{{ t("error-invalid-email") }}</p>
        <div class="btnArea">
          <button :class="{ disabled: !isValidEmail || email.length === 0 || isLoading }" type="button" @click.stop="onSendReport">
            {{ t("skillMonitor-assessment-send-report-button") }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {emailValidation} from '~/utils/ValidationUtil';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useToastStore} from '~/store/toast/toastStore';
import {ToastType} from '~/components/Common/Toast/model/ToastType';
import {useReportService} from '~/composables/service/useReportService';
import {ReportDomainType} from '~~/package/mapper/report/model/ReportDomainType';

const { t } = useI18n();

const dialogStore = useDialogStore();
const toastStore = useToastStore();
const reportService = useReportService();

const email = ref("");
const isLoading = ref(false);

const getDescriptionToHtml = computed(() =>
  t('skillMonitor-assessment-send-report-description', { pdf: `<span style="font-weight: 600">${t('skillMonitor-assessment-send-report-description-zip')}</span>`})
)

const isValidEmail = computed(() => emailValidation(email.value))

// RPT-BULK-02, ASMT-REPORT-08: 수신 이메일 입력 → POST /reports/export/bulk 요청
const onSendReport = () => {
  if(!isValidEmail.value || email.value.length === 0 || isLoading.value) return;
  isLoading.value = true;

  reportService.submitBulkReportExport(
      email.value,
      ReportDomainType.CUSTOM_ASSESSMENT,
      dialogStore.options.props.assessmentId ?? 0
  ).then((isSuccess: boolean) => {
    if(isSuccess) {
      toastStore.openToast({
        toastType: ToastType.SUCCESS,
        contents: t('skillMonitor-assessment-send-report-success'),
      });
    }
    else {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: t('skillMonitor-assessment-send-report-fail'),
      });
    }
  }).catch(() => {
    toastStore.openToast({
      toastType: ToastType.FAILED,
      contents: t('skillMonitor-assessment-send-report-fail'),
    });
  }).finally(() => {
    isLoading.value = false;
    onClickClose()
  })
}

const onClickClose = () => {
  dialogStore.close();
}
</script>
